export enum AppliancesRoles {
  VIEWER = 'roles.appliancesViewer',
  MANAGER = 'roles.appliancesManager',
}
